export const isOffsetInPixels = offset =>
  typeof offset === 'string' && offset.includes('px');
